import { apiRequest } from "../api.jsx";

export const createSupportTicket = ({ subject, message, category }) =>
  apiRequest("/support/tickets", "POST", { subject, message, category });

export const getMySupportTickets = (params = "") =>
  apiRequest(`/support/tickets${params ? `?${params}` : ""}`);

export const getSupportTicket = (ticketId) =>
  apiRequest(`/support/tickets/${encodeURIComponent(ticketId)}`);
